/**
 * @prettier
 * @flow
 */
import Box from '@material-ui/core/Box';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import amex from 'payment-icons/min/flat/amex.svg';
import mastercard from 'payment-icons/min/flat/mastercard.svg';
import visa from 'payment-icons/min/flat/visa.svg';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { theme } from 'src/AppRoot';
import { translate } from 'src/utils/translate/translate';

export function FormCardNumberField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const classes = useStyles();

    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();
    // const { errors, control, formState: { isSubmitting }, watch } = useFormContext();

    // const v = watch(name);

    const minLength = 13;
    const maxLength = 19;

    return (
        <Controller
            as={TextField}
            name={`${name}.cardNumber`}
            label={label}
            placeholder={'1234 1234 1234 1234'}
            // helperText={errors[name]?.['cardNumber']?.message ?? helperText}
            rules={{
                required: {
                    value: rules?.required,
                    message: translate('Card number is required'),
                },
                minLength: {
                    value: minLength,
                    message: translate('Invalid card number'),
                },
                maxLength: {
                    value: maxLength,
                    message: translate('Invalid card number'),
                },
            }}
            error={!!errors[name]?.['cardNumber']}
            value={value}
            onChange={onChange}
            InputProps={{
                inputComponent: NumberFormatCustom,
                ...InputProps,
                endAdornment: (
                    <InputAdornment position='end'>
                        <img src={visa} alt='' height={theme.spacing(2.5)} />
                        <Box p={0.25} />
                        <img src={mastercard} alt='' height={theme.spacing(2.5)} />
                        <Box p={0.25} />
                        <img src={amex} alt='' height={theme.spacing(3)} />
                    </InputAdornment>
                ),
            }}
            inputProps={{ autoComplete: 'cc-number' }}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
            classes={{ root: classes.input }}
        />
    );
}

export function NumberFormatCustom(props: { inputRef: any, name: string, onChange: Function }) {
    const { inputRef, onChange, ...other } = props;

    return <NumberFormat {...other} getInputRef={inputRef} onValueChange={values => onChange(values.value)} thousandSeparator isNumericString format='#### #### #### #### ####' decimalScale={0} />;
}

const useStyles = makeStyles(theme => ({
    input: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                // borderBottomColor: 'white',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },
            '&:hover fieldset': {
                // borderBottomColor: 'white',
            },
            '&.Mui-focused fieldset': {
                // borderBottomColor: 'white',
            },
        },
    },
}));

type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
    |},
    InputProps?: any,
    defaultValue?: string,
|};
